import React, { useState, useEffect } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import LoanDetails from "views/admin/components/LoanDetails";
import { Grid, IconButton } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { formatDate, parseDate, formatMoney } from "utils/Utils";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import ToastModal from "views/components/ToastModal";
import { adjustDate } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
const useStyles = makeStyles(styles);

const statusList = [
  "SUBMITTED",
  "ASSIGNED",
  "INPROCESS",
  "DISBURSAL",
  "REJECTED",
  "COMPLETED",
  "SANCTIONED",
];
const submitColumns = [
  { id: "LoanRequestNum", label: "Loan Request Num" },
  { id: "ProposedLoanAmt", label: "Proposed Loan Amt" },
  { id: "CreatedDate", label: "Created Date" },
];
const submitAssignColumns = [
  { id: "LoanRequestNum", label: "Loan Request Num" },
  { id: "ProposedLoanAmt", label: "Proposed Loan Amt" },
  { id: "BranchName", label: "Branch Name" },
  { id: "AssignedTo", label: "Assigned To" },
  { id: "CreatedDate", label: "Created Date" },
  { id: "Action", label: "Action" },
];
const reportRejectColumns = [
  { id: "LoanRequestNum", label: "Loan Request Num" },
  { id: "ProposedLoanAmt", label: "Proposed Loan Amt" },
  { id: "BranchName", label: "Branch Name" },
  { id: "Reason", label: "Reason" },
  { id: "AdditionalNotes", label: "Additional Notes" },
  { id: "CreatedDate", label: "Created Date" },
];
const Report = ({seletedBranchCode}) => {
  const classes = useStyles();

  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [loanDetails, setLoanDetails] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("SUBMITTED");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedPageIndex, setSelectedPageIndex] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [overAllStatus, setOverAllStatus] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [unAssignLoanApplicationId, setUnAssignLoanApplicationId] =
    useState("");
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastMessageType, setToastMessageType] = useState('');
  const [anchorActionEl, setAnchorActionEl] = useState(null);
  //goldRate
  const [tableColumnsGoldRate, setTableColumnsGoldRate] = useState([
    "Date",
    "Fineness Code",
    "Lending Rate",
    "Userid",
  ]);
  const [fileGoldRateData, setFileGoldRateData] = useState([]);
  // Application
  const [tableColumnsApplication, setTableColumnsApplication] = useState([
    "Loan Req No",
    "Name",
    "Amount",
    "Address",
    "pinCode",
    "mobileNo",
    "Status(Assign/Pending)",
    "Assign to",
  ]);
  const { authToken } = useSelector((state) => state.login.authData);
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const branchCodeSend = seletedBranchCode ? seletedBranchCode : userDetails?.branchCode;
  useEffect(() => {
    GetAllReportsData();
    GetGoldRateData();
    GetAllLeadCount();
  }, []);
  const GetAllLeadCount = async () => {
    const loanResult = await apiHandler({
      url: endpoint.LEAD_REPORT_COUNT,
      authToken: authToken,
    });
    setTotalCount(loanResult?.data?.totalApplicationCount);
  };
  const GetAllReportsData = async () => {
    let totalCount = 0;
    statusList.forEach(async (status) => {
      const apiStatus = status === "DISBURSAL" ? "DISBURSAL_INITIATED" : status;
      //ADMIN_LOANAPPLICANTIONFINDBYSTATUS
      const loanResult = await apiHandler({
        url:
          endpoint.LEAD_REPORT_DATA +
          `${apiStatus}&branchCode=` +
          branchCodeSend + "&from=" + parseDate(adjustDate(-15)) + "&to=" + parseDate(new Date()),
        authToken: authToken,
      });

      if (loanResult.data.error_code) {
        console.error(loanResult.data.user_description);
      } else {
        let updatedStatus = overAllStatus;
        const count =
          updatedStatus && updatedStatus[status] && updatedStatus[status].count
            ? updatedStatus[status].count
            : 0;
        updatedStatus[status] = loanResult.data;
        totalCount = totalCount + +updatedStatus[status].count - +count;
        setTotalCount(totalCount);
        setOverAllStatus(updatedStatus);
        showLoanRecords(selectedStatus);
      }
    });
  };
  const showLoanRecords = (status) => {
    setSelectedStatus(status);
    let applications = overAllStatus[status];
    if (status === "SUBMITTED") {
      setTableColumns(submitColumns);
    } else if (status === "REJECTED") {
      setTableColumns(reportRejectColumns);
    } else {
      setTableColumns(submitAssignColumns);
    }
    parseIndicatorData(status, applications);
  };

  const parseIndicatorData = (status, data) => {
    data?.applications?.sort(
      (a, b) =>
        new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
    );
    let reportData = [];
    data &&
      data.applications.forEach((goldpay, index) => {
        if (status === "SUBMITTED") {
          let row = {
            LoanRequestNum: getLoanDetailsLink(
              goldpay.id,
              goldpay.loanRequestNum
            ),
            ProposedLoanAmt: goldpay.proposedLoanAmt,
            CreatedDate: formatDate(goldpay.createdOn),
          };
          reportData.push(row);
        } else if (status === "ASSIGNED") {
          let row = {
            LoanRequestNum: getLoanDetailsLink(
              goldpay.id,
              goldpay.loanRequestNum
            ),
            ProposedLoanAmt: goldpay.proposedLoanAmt,
            BranchName: goldpay.branchName,
            AssignedTo: goldpay.agentName,
            CreatedDate: formatDate(goldpay.createdOn),
            Action: getActionLink(goldpay.id),
          };
          reportData.push(row);
        } else if (status === "REJECTED") {
          let row = {
            LoanRequestNum: getLoanDetailsLink(
              goldpay.id,
              goldpay.loanRequestNum
            ),
            ProposedLoanAmt: goldpay.proposedLoanAmt,
            BranchName: goldpay.branchName,
            Reason: goldpay.reason,
            AdditionalNotes: goldpay.text,
            CreatedDate: formatDate(goldpay.createdOn),
          };
          reportData.push(row);
        } else {
          let row = {
            LoanRequestNum: getLoanDetailsLink(
              goldpay.id,
              goldpay.loanRequestNum
            ),
            ProposedLoanAmt: goldpay.proposedLoanAmt,
            BranchName: goldpay.branchName,
            AssignedTo: goldpay.agentName,
            CreatedDate: formatDate(goldpay.createdOn),
          };
          reportData.push(row);
        }
      });
    let selectedList = reportData.slice(
      (selectedPageIndex - 1) * rowsPerPage,
      selectedPageIndex * rowsPerPage
    );
    setSelectedTableData(selectedList);
    setTableData(reportData);
  };
  const getActionLink = (loanApplicationId) => {
    return (
      <>
        <IconButton
          aria-label="Un-assign Agent"
          onClick={(event) => onActionClick(event, loanApplicationId)}
          style={{ backgroundColor: "inherit" }}
        >
          <EditIcon />
        </IconButton>
      </>
    );
  };
  const getLoanDetailsLink = (loanApplicationId, link) => {
    return link !== "" ? (
      <Link
        style={{ cursor: "pointer" }}
        onClick={() => onLoanDetails(loanApplicationId)}
        to=""
      >
        {link}
      </Link>
    ) : null;
  };
  const handleActionMenuClose = () => {
    setAnchorActionEl(null);
  };
  const onActionClick = (event, loanApplicationId) => {
    setAnchorActionEl(event.currentTarget);
    setUnAssignLoanApplicationId(loanApplicationId);
  };
  const unAssignLoanApplication = async () => {
    handleActionMenuClose();
    // ADMIN_LOANAPPLICATIONUNASSIGN
    const response = await apiHandler({
      url: endpoint.ADMIN_LOANAPPLICATIONUNASSIGN,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: unAssignLoanApplicationId,
      },
    });
    setUnAssignLoanApplicationId("");
    GetAllReportsData();
  };
  const onLoanDetails = async (loanApplicationId) => {
    // Get Loan Application Details
    //CUSTOMER_APPLICATIONFINDID
    const result = await apiHandler({
      url: endpoint.CUSTOMER_APPLICATIONFINDID + loanApplicationId,
      authToken: authToken,
    });
    // Loan Details Modal
    setLoanDetails(result.data);
    setShowLoanDetails(true);
  };
  const closeLoanModal = () => {
    setShowLoanDetails(false);
    setLoanDetails({});
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);

  };

  const getOverAllStatusCards = () => {
    return statusList.map((status, i) => {
      return (
        <GridItem xs={6} sm={4} md={4} lg={2} key={i}>
          <Card
            style={{
              cursor: "pointer",
              height: "100%",
            }}
            onClick={() => showLoanRecords(status)}
          >
            <CardHeader
              style={{
                padding: "12px"
              }}
            >
              <h3
                className={classes.cardCategory}
                style={{
                  fontWeight: selectedStatus === status ? "bold" : "normal",
                  fontSize: "14px",
                  wordBreak: "break-word",
                }}
              >
                {toCamelCase(status)}
              </h3>

              <h3
                className={classes.cardTitle}
                style={{
                  fontSize: "16px",
                }}
              >
                {overAllStatus &&
                overAllStatus[status] &&
                overAllStatus[status]?.count > 0
                  ? overAllStatus[status]?.count
                  : 0}
                /{totalCount}
              </h3>
            </CardHeader>
          </Card>
        </GridItem>
      );
    });
  };
  // goldRate
  const GetGoldRateData = async () => {
    const resultgoldRate = await apiHandler({
      url: endpoint.ADMIN_GOLDRATE_FINDALL,
      authToken: authToken,
    });
    if (resultgoldRate.data.error_code) {
      toastUpdate("Error", resultgoldRate?.data?.user_description, true);
    } else {
      parseIndicatorGoldRateData(resultgoldRate.data);
    }
  };
  const parseIndicatorGoldRateData = (data) => {
    //let reportData = [];
    let downloadgoldRateData = [];
    downloadgoldRateData.push(tableColumnsGoldRate);

    data &&
      data.forEach((goldpay) => {
        downloadgoldRateData.push([
          goldpay.date,
          goldpay.purity,
          formatMoney(goldpay.lendingPrice) + " " + goldpay.currencyCode,
          goldpay.createdBy,
        ]);
      });
    setFileGoldRateData(downloadgoldRateData);
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader label="Leads" />
        </Grid>
      </Grid>
      <GridContainer spacing={2}>
        {getOverAllStatusCards()}
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ overflowX: "auto" }}>
            <ColumnGroupingTable
              columns={tableColumns}
              rows={selectedTableData}
            />
          </div>
          <Menu
            id="action-menu"
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            MenuListProps={{
              style: {
                border: "1px solid #d3d4d5",
                borderRadius: "3px",
              },
            }}
            anchorEl={anchorActionEl}
            keepMounted
            open={Boolean(anchorActionEl)}
            onClose={() => handleActionMenuClose()}
          >
            <MenuItem onClick={() => unAssignLoanApplication()}>
              {"UnAssign"}
            </MenuItem>
          </Menu>
        </GridItem>
        <LoanDetails
          showModal={showLoanDetails}
          trade={loanDetails}
          closeModal={closeLoanModal}
        />
       
   {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      </GridContainer>
    </div>
  );
};

export default Report;
